import classNames from 'classnames';
import * as React from 'react';
import styles from './TopArea.module.scss';

export interface TopAreaProps {
	additional?: {
		top?: React.ReactNode;
		alerts?: React.ReactNode;
		languageBar?: React.ReactNode;
		bottom?: React.ReactNode;
	};
	fullWidth?: {
		hasFullWidthLanguageBar: boolean, 
		hasFullWidthBanner: boolean,
		hasFullWidthHeader: boolean
	}
	headerComponents?: boolean;
	additionalNoPadding?: boolean;
	topBanner?: React.ReactNode;
}

export const TopArea: React.FC<TopAreaProps> = ({ additional, additionalNoPadding, fullWidth, headerComponents, topBanner }) => {
	return (
		<>
			{additional && (
				<>
					<div className={classNames(styles.TopArea_additional, 
							{ [styles.TopArea_additional___noLanguageBar] : !additional?.languageBar && true },
							{ [styles.TopArea_additional___noBreadcrumb] : !additional?.top && true },
							{ [styles.TopArea_additional___noContent] : !additional?.top && !additional?.languageBar && true }
						)}>
						{additional?.top && (
							<div
								className={classNames(
									styles.TopArea_additionalWrapper,
									styles.TopArea_additionalWrapper___top,
									additionalNoPadding && styles.TopArea_additionalWrapper___noPadding,
								)}
							>
								<div className={styles.TopArea_additionalContainer}>{additional.top}</div>
							</div>
						)}
						{additional?.alerts && (
							<div
								className={classNames(
									styles.TopArea_alertsWrapper,
									styles.TopArea_additionalWrapper___bottom,
								)}
							>{additional.alerts}</div>
						)}
						{additional?.languageBar && (
							<div
								className={classNames(
									styles.TopArea_languageBarWrapper,
									{[ styles.TopArea_languageBarWrapper___fullWidth] : fullWidth?.hasFullWidthLanguageBar && true },
									{[ styles.TopArea_languageBarWrapper___headerComponents] : headerComponents },
									additionalNoPadding && styles.TopArea_additionalWrapper___noPadding,
								)}
							>
								<div className={styles.TopArea_languageBarContainer}>
									<div className={styles.TopArea_languageBarInnerContainer}>{additional.languageBar}</div>
								</div>
							</div>
						)}
					</div>
				</>
			)}
			{topBanner && (
				<div className={classNames(
					styles.TopArea_banner, 
					{[ styles.TopArea_banner___fullWidth] : fullWidth.hasFullWidthBanner && true },
					{[ styles.TopArea_banner___noTopMargin] : additional?.languageBar && true },
				)}>{topBanner}</div>
			)}
		</>
	);
};
